export default __webpack_public_path__ + "static/media/epmaps-logo.d1cfec85.png";